<template>
    <div id="app">
        <div class="wrap">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
};
</script>

<style>
.wrap {
    display: flex;
    justify-content: center;
}
</style>
